<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="mobileDeviceViewing" v-show="!isEditing">
              <div class="form-group">
                <p style="font-size:35px">{{ mobileDevice.name }}</p>
                <div class="row">
                  <div class="col-md-5">
                    <p>MDM Device ID: {{mobileDevice.mdm_device_id != null ? mobileDevice.mdm_device_id : "Not Set"}}
                    <p>{{mobileDevice.assigned == true ? 'Device has been assigned': "Device hasn't been assigned"}}</p>
                    <p>{{mobileDevice.chat == true ? 'Wire is Enabled': 'Wire is Disabled'}}</p>
                    <br>
                    <!-- <data-table :data="mobileDevice.props.users" :columns="gridColumns" :filter-key="searchQuery"></data-table>
                    <br> -->
                    <button v-on:click="edit" v-if="org['curOrg']['role'] == 99" type="button" class="btn  btn-default form-group">Edit</button>
                    <button type="button" data-toggle="modal" data-target="#showQRCodeModal" class="btn btn-info form-group">ShowQRCode</button>
                  </div>
                  <div class="col-md-5" v-if="mobileDevice.mdm_device_id != null">
                    <div v-if="!showMdmDeviceData">
                      <button v-on:click="fetchMDMDeviceData" type="button" class="btn btn-default">Show MDM Data</button>
                    </div>
                    <div v-else>
                      <div v-if="mdmDeviceData.device">
                        <p>Device Name: {{mdmDeviceData.device.device_name}}</p>
                        <p>OS Version: {{mdmDeviceData.device.os_name}} {{mdmDeviceData.device.os_version}}</p>
                        <p>Last Battery Level: {{Math.round(mdmDeviceData.device.battery_level)}}%</p>
                        <p>Last Seen: {{new Date(mdmDeviceData.lastreported).toLocaleString()}}</p>
                      </div>
                      <div v-else-if="mdmDeviceData.error">
                        <p>MDM Data Error: {{mdmDeviceData.error.message}}</p>

                        <p>Are you sure the MDM Device ID is correct?</p>
                      </div>
                      <div v-else>
                        <stretch-loading></stretch-loading>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Editing-->
            <div class="mobileDeviceEditing col-md-5"  v-if="org['curOrg']['role'] == 99" v-show="isEditing">
              <form-text styler="font-size:35px" ref="name" label="Name" name="name" v-model="mobileDeviceEdit.name" validation="required"></form-text>
              <form-text label="MDM Device ID" name="mdm_device_id" v-model="mobileDeviceEdit.mdm_device_id"></form-text>
              <br>
              <h5>Wire</h5>
              <form-checkbox label="Wire" name="chat" v-model="mobileDevice.chat"></form-checkbox>
              <!-- <div class="form-group">
                 <v-select placeholder="Assigned Users" multiple :options="allUsers" label="name" name="users" :value.sync="mobileDeviceEdit.props.users"></v-select>
              </div> -->             
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
                <button v-if="mobileDevice.assigned == true" type="button" data-toggle="modal" data-target="#unassignDeviceModal" class="btn btn-warning form-group rightey">Unassign Device</button>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
    </div><!-- /.col-md-3 -->

    <showqrcode :deviceid="mobileDevice['.key']" name="showQRCodeModal"></showqrcode>
    <unassigndevice @unassignDevice="unassignDevice" name="unassignDeviceModal"></unassigndevice>
  </div>    
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../../elements/Form/FormText'
import ActiveFormCheckbox from '../../../elements/Form/ActiveFormCheckbox'
import database from '../../../webmaster/Database/database'
import store from "../../../webmaster/Store/vuex";

import firebase from 'firebase'

import ShowQRCodeModal from './ShowQRCodeModal'
import UnassignDeviceModal from './UnassignDeviceModal'

import MDMService from '@/services/MDMService.js'

import StretchLoading from '@/components/common/StretchLoading.vue'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'editmobileDevice',
  components:{
    'form-text': FormText,
    'showqrcode': ShowQRCodeModal,
    'unassigndevice': UnassignDeviceModal,
    'form-checkbox': ActiveFormCheckbox,
    'stretch-loading': StretchLoading,
  },
  data () {
    return {
      org: store.state.usermain,
      mobileDevice: {
        name: '',
        type: 'Mobile Device',
        mdm_device_id: '',
        chat: Boolean,
        assigned: Boolean,
        props:{
          users: []
        }
      },
      mobileDeviceEdit: {
        name: '',
        type: 'Mobile Device',
        mdm_device_id: '',
        chat: Boolean,
        assigned: Boolean,
        props:{
          users: []
        }
      },
      isEditing: false,
      searchQuery: '',
      gridColumns: ["Users"],
      allUsers: [],
      mdmDeviceData: {},
      showMdmDeviceData: false,
    }
  },
  created:function(){
    this.fetchAll()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchAll:function(){
      this.fetchmobileDevice()
      //this.fetchDeviceUsersTable()
      //this.fetchAllUsers()
    },
    fetchmobileDevice: function(){
      this.$bindAsObject('mobileDevice', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/devices/' + this.$route.params.id), null, function(){
        this.mobileDeviceEdit = Object.assign({}, this.mobileDeviceEdit, this.mobileDevice);
      });
    },
    async fetchMDMDeviceData() {
      const deviceId = this.mobileDevice.mdm_device_id;

      if (this.mobileDevice.mdm_device_id != null) {
        this.showMdmDeviceData = true;

        const idToken = await firebase.auth().currentUser.getIdToken();

        const data = await MDMService.getDevice(deviceId, idToken)

        console.log(data)

        this.mdmDeviceData = data;
      }
    },
    fetchAllUsers:function(){
      //Get all users
      var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/users'
      this.$bindAsArray('allUsers', database.getRef(ref));
    }, 
    fetchDeviceUsersTable:function(){
      var self = this
      var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices/' + this.$route.params.id + '/props/users'
      const userOrgs = database.getRef(ref)
      userOrgs.once('value').then(snap => {
        let userKeys = Object.keys(snap.val());
        self.mobileDevice.props.users = []
        userKeys.forEach(key => {
          var userRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/users/' + key
          const user = database.getRef(userRef)
          user.once('value').then(snapUser => {
            self.mobileDevice.props.users.push({
              ['.key']: key,
              name: snapUser.val().name
            })
          });
        });
        self.mobileDeviceEdit.props.users = self.mobileDevice.props.users
      });
    },
    submitEdit: function(e){
      e.preventDefault()
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var deviceUsers = {}
        for (var user in self.mobileDeviceEdit.props.users) {
            var obj = self.mobileDeviceEdit.props.users[user];
            deviceUsers[obj['.key']] ={
              empty: "empty"
            }
        }
        var device = {
          name: self.mobileDeviceEdit.name,
          type: self.mobileDeviceEdit.type,
          mdm_device_id: self.mobileDeviceEdit.mdm_device_id,
          chat: self.mobileDevice.chat || false,
          assigned: self.mobileDevice.assigned || false,
          props:{
            users: deviceUsers
          }
        }
        var curOrgId = self.$store.state.usermain.curOrg.id
        var deviceId = this.$route.params.id
        var updates = {};

        updates['/orgs/' + curOrgId + '/devices/' + deviceId] = device;

        database.getRef("/orgs/" + curOrgId + "/wire/users/" + deviceId).once('value').then(wireUserSnapshot => {
          if (wireUserSnapshot.val() != null) {
            updates["/orgs/" + curOrgId + "/wire/users/" + deviceId + "/name"] = device.name;

            if (wireUserSnapshot.val().chats != null) {
              var chatIds = Object.keys(wireUserSnapshot.val().chats);

              chatIds.forEach(function (chatId) {
                updates['/orgs/' + curOrgId + '/wire/chats/' + chatId + '/members/' + deviceId] = device.name;
              });
            }
          } else if (device.chat == true) {
            updates["/orgs/" + curOrgId + "/wire/users/" + deviceId] = {
              name: device.name,
              user_type: "mobile",
            };
          }
        }).then(function() {
          database.getDb().ref().update(updates, function(){
            self.isEditing = false
            self.fetchAll()
          });
        })

      }, () => {});
    },
    unassignDevice: function(){
      var curOrgId = this.$store.state.usermain.curOrg.id

      var self = this;

      var updates = {};
      updates['/orgs/' + curOrgId + '/devices/' + this.$route.params.id + '/assigned'] = false;
      database.getDb().ref().update(updates, function(){
        self.isEditing = false
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .rightey {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// EditMobileDevice.vue?650af5a8